/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：nlA+
 */

// removed by extract-text-webpack-plugin
module.exports = {
  "cocoToast": "cocoToast_y3-Yu"
}

/***/
